import { useCookieConsentContext } from '../../context/CookieConsentContext';

export function CookieBanner() {
  const { hasDecided, acceptAll, rejectAll, openPreferences } = useCookieConsentContext();

  if (hasDecided) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-surface-900 border-t border-surface-300 px-4 py-4 shadow-2xl">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-surface-100/70 flex-1">
          We use essential cookies for core functionality, maps, and video embeds.{' '}
          <a href="/cookies.html" className="text-primary-400 hover:text-primary-300 underline" target="_blank" rel="noopener noreferrer">
            Cookie Policy
          </a>
        </p>
        <div className="flex items-center gap-2 flex-shrink-0 flex-wrap">
          <button
            onClick={openPreferences}
            className="px-4 py-2 text-sm font-medium text-surface-100/70 hover:text-surface-50 bg-surface-700 hover:bg-surface-600 rounded-lg transition-colors border border-surface-300"
          >
            Manage
          </button>
          <button
            onClick={rejectAll}
            className="px-4 py-2 text-sm font-medium text-surface-100/70 hover:text-surface-50 bg-surface-700 hover:bg-surface-600 rounded-lg transition-colors border border-surface-300"
          >
            Essential Only
          </button>
          <button
            onClick={acceptAll}
            className="px-4 py-2 text-sm font-medium text-surface-900 bg-primary-400 hover:bg-primary-300 rounded-lg transition-colors font-semibold"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
